module.exports = __webpack_public_path__ + "img/MV.22e5a6d2.svg";